<template>
  <footer class="site-footer">
    <div class="footer-top overlay-black-dark">
      <div class="container">
        <div class="row">
          <div class="col-lg-3 col-md-6 col-sm-5 footer-col-4">
            <div class="widget widget_getintuch">
              <h6 class="m-b15 h6 text-uppercase">YEBO</h6>
              <div class="dlab-separator bg-white"></div>
              <ul class="info-contact">
                <li>
                  <a href="javascript:void(0);" class="footer-link-contact">
                    <i class="fa fa-map-marker	"></i> <span>Local 1306, Crown tower, Batetela. Gombe</span>
                  </a>
                </li>
                <li>
                  <a class="footer-link-contact" title="Appelez-nous à ce numéro" href="tel:+243823113167">
                    <i class="fa fa-phone"></i> <span>Mobile: +243 82 31 13 167</span>
                  </a>
                </li>
                <li>
                  <a class="footer-link-contact" title="Ecrivez-nous avec cette adresse e-mail" href="mailto:info@yebo.fr">
                    <i class="fa fa-envelope-o"></i> <span>Mail: info@yebo.fr</span>
                  </a>
                </li>
                <li>
                  <a href="javascript:void(0);" class="footer-link-contact">
                    <i class="fa fa-fax"></i> <span>Fax: 000 123 2294 089</span>
                  </a>
                </li>
              </ul>
            </div>
            <ul class="list-inline">
              <li><a href="javascript:void(0);" class="site-button facebook sharp"><i class="fa fa-facebook"></i></a></li>
              <li><a href="javascript:void(0);" class="site-button google-plus sharp"><i class="fa fa-google-plus"></i></a></li>
              <li><a href="javascript:void(0);" class="site-button linkedin sharp"><i class="fa fa-linkedin"></i></a></li>
              <li><a href="javascript:void(0);" class="site-button twitter sharp"><i class="fa fa-twitter"></i></a></li>
            </ul>
          </div>
          <div class="col-lg-3 col-md-6 col-sm-7 footer-col-4">
            <div class="widget  widget_tag_cloud">
              <h6 class="m-b15 h6 text-uppercase">Tags</h6>
              <div class="dlab-separator bg-white"></div>
              <div class="tagcloud">
                <a href="javascript:void(0);">Hotels</a>
                <a href="javascript:void(0);">Restaurants</a>
                <a href="javascript:void(0);">Tourisme</a>
                <a href="javascript:void(0);">Chambres</a>
                <a href="javascript:void(0);">Fruits</a>
                <a href="javascript:void(0);">Boissons</a>
                <a href="javascript:void(0);">Gastronomie</a>
                <a href="javascript:void(0);">Location Voiture</a>
                <a href="javascript:void(0);">Habillement</a>
                <a href="javascript:void(0);">Repassage</a>
                <a href="javascript:void(0);">Ménage</a>
                <a href="javascript:void(0);">Néttoyage</a>
                <a href="javascript:void(0);">Accompagnement</a>
                <a href="javascript:void(0);">Réservation</a>
                <a href="javascript:void(0);">Diner</a>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-md-6 col-sm-6 footer-col-4">
            <div class="widget widget_getintuch">
              <h6 class="m-b15 h6 text-uppercase">Contactez-nous</h6>
              <div class="dlab-separator bg-white"></div>
              <div class="search-bx">
                <div class="dzFormMsg"></div>
                <form method="post" action="">
                  <input type="hidden" value="Contact" name="dzToDo" >
                  <div class="input-group">
                    <label for="footer_contact_name"></label>
                    <input id="footer_contact_name" name="receiver_name" type="text" required class="form-control" placeholder="Nom complet">
                  </div>
                  <div class="input-group">
                    <label for="footer_contact_email"></label>
                    <input id="footer_contact_email" name="email" type="email" class="form-control" required  placeholder="Adresse e-mail">
                  </div>
                  <div class="input-group">
                    <label for="footer_contact_subject"></label>
                    <input id="footer_contact_subject" name="subject" type="text" class="form-control" required  placeholder="Sujet">
                  </div>
                  <div class="input-group">
                    <textarea id="footer_contact_message" name="message" rows="4" class="form-control" required placeholder="Message"></textarea>
                  </div>
                  <div class="input-group">
                    <button name="submit" type="submit" value="Submit" class="site-button "> <span>Envoyer</span> </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-md-6 col-sm-6 footer-col-4">
            <div class="widget widget_gallery">
              <h6 class="m-b15 h6 text-uppercase">GALLERIE</h6>
              <div class="dlab-separator bg-white"></div>
              <ul class="clearfix mfp-gallery">
                <li class="img-effect2">
                  <a class="mfp-link" href="../../assets/img/upload_images/offers/boisson.png" title="Title Come Here">
                    <img src="../../assets/img/upload_images/offers/boisson.png" alt=""></a>
                </li>
                <li class="img-effect2">
                  <a class="mfp-link" href="../../assets/img/upload_images/offers/chambre.png" title="Title Come Here">
                    <img src="../../assets/img/upload_images/offers/chambre.png" alt=""></a>
                </li>
                <li class="img-effect2">
                  <a class="mfp-link" href="../../assets/img/upload_images/offers/desserts.png" title="Title Come Here">
                    <img src="../../assets/img/upload_images/offers/desserts.png" alt=""></a>
                </li>
                <li class="img-effect2">
                  <a class="mfp-link" href="../../assets/img/upload_images/offers/exposition.png" title="Title Come Here">
                    <img src="../../assets/img/upload_images/offers/exposition.png" alt=""></a>
                </li>
                <li class="img-effect2">
                  <a class="mfp-link" href="../../assets/img/upload_images/offers/massage.png" title="Title Come Here">
                    <img src="../../assets/img/upload_images/offers/massage.png" alt=""></a>
                </li>
                <li class="img-effect2">
                  <a class="mfp-link" href="../../assets/img/upload_images/offers/parcs_bonobo.png" title="Title Come Here">
                    <img src="../../assets/img/upload_images/offers/parcs_bonobo.png" alt=""></a>
                </li>
                <li class="img-effect2">
                  <a class="mfp-link" href="../../assets/img/upload_images/offers/pizzeria.png" title="Title Come Here">
                    <img src="../../assets/img/upload_images/offers/pizzeria.png" alt=""></a>
                </li>
                <li class="img-effect2">
                  <a class="mfp-link" href="../../assets/img/upload_images/offers/repassage.png" title="Title Come Here">
                    <img src="../../assets/img/upload_images/offers/repassage.png" alt=""></a>
                </li>
                <li class="img-effect2">
                  <a class="mfp-link" href="../../assets/img/upload_images/offers/voiturier.png" title="Title Come Here">
                    <img src="../../assets/img/upload_images/offers/voiturier.png" alt=""></a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- footer bottom part -->
    <button class="scroltop fa fa-plane"></button>
  </footer>
</template>

<script>
import {mapGetters, mapMutations, mapActions} from 'vuex'

export default {
  name: "Footer",
  props: {},
  components: {},
  data(){
    return{}
  },
  methods: {
    ...mapMutations([]),
    ...mapActions([]),
  },
  computed: {
    ...mapGetters([]),
  },
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {}
}
</script>

<style lang="scss" scoped>
footer{}

@media (min-width: 576px) {
  footer{}
}

@media (min-width: 768px) {
  footer{}
}

@media (min-width: 992px) {
  footer{}
}

@media (min-width: 1200px) {
  footer{}
}
</style>



// WEBPACK FOOTER //
// src/components/shared/Footer.vue